// ExpandableParagraph.js
import React, { useState } from "react";
import "./ExpandableParagraph.css"
import RenderHtmlFormattedText from "../../../../../HtmlElements/RenderHtmlFormattedText";

export default function ExpandableParagraph({ text, wordLimit = 100 }) {
  const [expanded, setExpanded] = useState(false);

  const words = text.split(' ');
  const isLong = words.length > wordLimit;

  const displayText = expanded ? text : words.slice(0, wordLimit).join(' ') + (isLong ? '...' : '');

  return (
    <div>
      <p className=""><RenderHtmlFormattedText htmlContent={displayText} />
      {isLong && (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setExpanded(!expanded)}}
          className="expandable-para-view-toggle-btn"
        >
          {expanded ? 'View Less' : 'View More'}
        </div>
      )}
      </p>
    </div>
  );
}
